import moment from 'moment-timezone'
export type MonthFormat = 'numeric' | '2-digit' | 'long' | 'short' | 'narrow'

export class DateUtils {
  public static formattedDateString(str: string, monthFormat: MonthFormat = 'long'): string {
    const d = new Date(str)
    const month = d.toLocaleString('default', { month: monthFormat })
    return `${d.getDate()} ${month} ${d.getFullYear()}`
  }

  public static convertToUTC(date?: string | null): string | null {
    if (!date) return null
    return moment(date).utc().format()
  }
}
